import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Col,
  Row,
  Table,
} from "reactstrap";
import './CropAcreage.css'
import Storage from "../services/Storage";
import { Roles } from '../constants/Roles';

const CropAcreage = ({ previewData, userId }) => {
  const navigate = useNavigate();
  const location = useLocation();
  let userInfo = Storage.getUserInfoDetail();
  let roleId = userInfo ? userInfo.id : null;
  let roleName = userInfo ? userInfo.role : '';

  const setBreadcrumbsRecord = () => {
    if (previewData.business_name) {
      Storage.setBreadcrumbsrRecord([
        {
          title: 'Preview App',
          url: location.pathname,
        },
        {
          title: previewData.business_name,
          url: `/pages/new-dealer/${previewData.id}`,
        },
      ])
    }
  }

  return (
    <div id='cropInfo'>
      <Row>
        <Col xs={12}>
          <div className='main-title'>Coverage Area Details
            {roleName && (roleName === Roles.TM_NAME || roleName === Roles.BH_NAME || (roleName === Roles.SH_NAME && previewData.created_by && previewData.created_by === roleId)) ?
              <i onClick={() => {
                setBreadcrumbsRecord();
                navigate({
                  pathname: `/pages/crop-acreages/${Storage.getAddNewDealerId() ? Storage.getAddNewDealerId() : userId}`
                })
              }} className='fa fa-edit editButton noprint'></i>
              : ""}
          </div>
        </Col>
        {(previewData.kharif_crop_name_1 || previewData.kharif_crop_name_2 || previewData.kharif_crop_name_3 || previewData.kharif_crop_name_4 || previewData.kharif_crop_acreages_1 || previewData.kharif_crop_acreages_2 || previewData.kharif_crop_acreages_3 || previewData.kharif_crop_acreages_4) &&
          <Col xs={12}>
            <div className='common-title'>Kharif Crops</div>
            <Table responsive className='cropTable mb-3'>
              <thead>
                <tr>
                  <th>Crop Name</th>
                  <td>{previewData.kharif_crop_name_1}</td>
                  <td>{previewData.kharif_crop_name_2}</td>
                  <td>{previewData.kharif_crop_name_3}</td>
                  <td>{previewData.kharif_crop_name_4}</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">Crop Acreages (in Acres)</th>
                  <td>{previewData.kharif_crop_acreages_1}</td>
                  <td>{previewData.kharif_crop_acreages_2}</td>
                  <td>{previewData.kharif_crop_acreages_3}</td>
                  <td>{previewData.kharif_crop_acreages_4}</td>
                </tr>
              </tbody>
            </Table>
          </Col>
        }
        {(previewData.rabi_crop_name_1 || previewData.rabi_crop_name_2 || previewData.rabi_crop_name_3 || previewData.rabi_crop_name_4 || previewData.rabi_crop_acreages_1 || previewData.rabi_crop_acreages_2 || previewData.rabi_crop_acreages_3 || previewData.rabi_crop_acreages_4) &&
          <Col xs={12}>
            <div className='common-title'>Rabi Crops</div>
            <Table responsive className='cropTable mb-0'>
              <thead>
                <tr>
                  <th scope="row">Crop Name</th>
                  <td>{previewData.rabi_crop_name_1}</td>
                  <td>{previewData.rabi_crop_name_2}</td>
                  <td>{previewData.rabi_crop_name_3}</td>
                  <td>{previewData.rabi_crop_name_4}</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">Crop Acreages (in Acres)</th>
                  <td>{previewData.rabi_crop_acreages_1}</td>
                  <td>{previewData.rabi_crop_acreages_2}</td>
                  <td>{previewData.rabi_crop_acreages_3}</td>
                  <td>{previewData.rabi_crop_acreages_4}</td>
                </tr>
              </tbody>
            </Table>
          </Col>
        }
      </Row>
    </div>
  )
}

export default CropAcreage